const INITIAL_STATE = {
  loading: false,
  error: null,
  data: null,
};

export default function marketplaceSetupReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "MARKETPLACE_SETUP_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "MARKETPLACE_SETUP_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case "MARKETPLACE_SETUP_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "MARKETPLACE_SETUP_RESET":
      return INITIAL_STATE;

    default:
      return state;
  }
}